import { useWidget } from '../../../providers/widget'
import { AmenitiesWidgetConfig } from '../config'
import { useFetchAmenities } from '../data'
import AmenitiesSkeleton from './AmenitiesSkeleton'
import AmenitiesList from './AmenitiesList'
import WidgetDataError from '../../../components/WidgetDataError'

export default function AmenitiesContent() {
  const { options } = useWidget<AmenitiesWidgetConfig>()

  const { data, isLoading, isError, error } = useFetchAmenities(
    options.filter
  )

  if (isLoading) {
    return <AmenitiesSkeleton />
  }

  if (isError) {
    return <WidgetDataError error={error} />
  }

  if (!data?.result?.amenities || data.result.amenities.length === 0) {
    return null
  }

  return <AmenitiesList amenities={data.result.amenities} />
}
